import styled, { css } from 'styled-components'

import { color, fontFamily, fontWeight, fontSize, space } from 'theme/utils'

type ButtonVariant = 'secondary' | 'tertiary'

export const buttonStyles = css`
  align-items: center;
  background: var(--background);
  border-color: var(--borderColor);
  border-style: solid;
  border-width: var(--borderWidth);
  color: var(--textColor);
  display: flex;
  font-family: ${fontFamily('base')};
  font-size: var(--textSize);
  font-weight: ${fontWeight('base')};
  height: var(--height);
  justify-content: center;
  letter-spacing: 0.1rem;
  min-width: min(var(--minWidth), 100%);
  padding: var(--padding);
  text-transform: uppercase;
  transition: 0.1s background-color;
  will-change: background-color;

  svg {
    transform: translateZ(0);
    path {
      fill: currentColor;
    }
  }

  &:hover:not([disabled]) {
    background: var(--backgroundHover);
    border-color: var(--borderColorHover);
    color: var(--textColorHover);
  }

  &.active:not([disabled]),
  &:active:not([disabled]) {
    background: var(--backgroundHover);
    border-color: var(--borderColorHover);
    color: var(--textColorHover);
  }

  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
  }
`
export const primaryVars = css`
  --background: ${color('white')};
  --backgroundDisabled: ${color('disabled')};
  --backgroundHover: ${color('black')};
  --borderColor: transparent;

  --borderHover: transparent;
  --borderHoverDisabled: transparent;
  --borderWidth: 0;

  --height: 80px;
  --minWidth: 240px;
  --padding: ${space(2)} ${space(6)};

  --textColor: ${color('text')};
  --textColorDisabled: ${color('text')};
  --textColorHover: ${color('white')};
  --textSize: ${fontSize('large')};
`

export const secondaryVars = css`
  /* --background: ${color('secondary')};
  --backgroundDisabled: ${color('disabled')};
  --backgroundHover: ${color('primary')};
  --borderColor: ${color('primary')};

  --borderHover: ${color('secondary')};
  --borderHoverDisabled: ${color('disabled')};
  --borderWidth: 2px;

  --height: 80px;
  --minWidth: 240px;
  --padding: ${space(2)} ${space(6)};

  --textColor: ${color('primary')};
  --textColorDisabled: ${color('text')};
  --textColorHover: ${color('secondary')};

  --textSize: ${fontSize('base')}; */
`

export const tertiaryVars = css`
  /* --background: ${color('tertiary')};
  --backgroundDisabled: ${color('disabled')};
  --backgroundHover: ${color('secondary')};
  --borderColor: ${color('secondary')};

  --borderHover: ${color('tertiary')};
  --borderHoverDisabled: ${color('disabled')};
  --borderWidth: 2px;

  --height: 80px;
  --minWidth: 90px;
  --padding: ${space(2)} ${space(6)};

  --textColor: ${color('secondary')};
  --textColorDisabled: ${color('text')};
  --textColorHover: ${color('tertiary')};

  --textSize: ${fontSize('base')}; */
`
export const smallVars = css`
  --height: 46px;
  --minWidth: 46px;
  --textSize: ${fontSize('small')};
`
export const largeVars = css`
  --height: 120px;
  --minWidth: 380px;
  --textSize: ${fontSize('large')};
`

export const Button = styled.button<{
  $variant?: ButtonVariant
  size?: 'small' | 'medium' | 'large'
  $noPadding?: boolean
}>`
  border-radius: var(--height);
  ${({ $noPadding }) =>
    $noPadding
      ? css`
          --padding: 0;
        `
      : ''}

  ${({ $variant }) => {
    if ($variant === 'secondary') return secondaryVars
    if ($variant === 'tertiary') return tertiaryVars
    return primaryVars
  }}

  ${({ size }) => {
    if (size === 'large') {
      return largeVars
    }
    if (size === 'small') {
      return smallVars
    }
    return
  }}
  ${buttonStyles};
`
